<div class="stackblitz__wrapper">
    <span
        mc-link
        (click)="openStackBlitz()">
        <svg mc-icon class="stackblitz__icon" width='9.5px' height='14px' viewBox='0 0 23 34' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <desc>Created with Sketch.</desc> <g id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'> <g class='stackblitz__icon-g'> <polygon id='Path' points='0 19.9187087 9.87007874 19.9187087 4.12007874 34 23 13.9612393 13.0846457 13.9612393 18.7893701 0'></polygon> </g> </g> </svg>
        <span class="mc-link__text">Stackblitz</span>
  </span>
</div>
